// frontend/src/components/ActivityLogger.tsx
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { auditApi } from '@/services/api'

/**
 * Registra actividad del usuario:
 *  · `login`     — una vez por sesión de navegador.
 *  · `page_view` — la ruta del frontend visitada, en cada cambio de ruta (va a `name`).
 * El `sesion_id` lo adjunta `auditApi.log` automáticamente. No pinta nada.
 */
export function ActivityLogger() {
  const location = useLocation()

  // login: solo la primera vez en esta sesión de navegador.
  useEffect(() => {
    const KEY = 'airval_audit_login'
    if (sessionStorage.getItem(KEY)) return
    sessionStorage.setItem(KEY, '1')
    auditApi.log({ accion: 'login' })
  }, [])

  // page_view: ruta del frontend en cada cambio de pathname.
  useEffect(() => {
    auditApi.log({ accion: 'page_view', ruta: location.pathname })
  }, [location.pathname])

  return null
}
